import { UseFormRegisterReturn, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { BusinessPayment } from "../../../service/model/business-payment.model";
import { Box, Button, Dialog, DialogTitle, Grid, Typography } from "@mui/material";
import FormField from "../../../components/form-controls/form-field";
import theme from "../../../app/app-theme";
import FormCloseButton from "../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";

interface BusinessPaymentFormProps {
    readonly payment?: BusinessPayment
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: BusinessPayment) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const validationSchema = yup.object().shape({
    amount: yup.number().transform((value) => Number.isNaN(value) ? null : value).required("Amount is required"),
    paymentDate: yup.string().required("Payment date is required"),
    fromDate: yup.string().required("From date is required")
});

export type FormValues = yup.InferType<typeof validationSchema>;

const BusinessPaymentForm: React.FC<BusinessPaymentFormProps> = ({ payment, editable, onClose, onSubmit }) => {
   
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmitHandler = (data: any) => {
        const updatedBusinessPayment = {
            ...payment,
            ...data
        }
        onSubmit(updatedBusinessPayment as BusinessPayment)
    };

    const getRegister = (name: keyof FormValues, validation?: any): UseFormRegisterReturn => {
        return register(name, validation);
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Payment Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, borderBottom: '1px solid #ccc' }}>
                            <Typography variant="body1" gutterBottom>
                                {payment?.businessName}
                            </Typography>
                        </Box>
                        <FormField>
                            <FormTextField
                                id="amount"
                                label="Amount"
                                name="amount"
                                type="number"
                                variant="outlined"
                                defaultValue={payment?.amount}
                                errorMessage={errors.amount?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="paymentDate"
                                label="Payment Date"
                                name="paymentDate"
                                type="date"
                                variant="outlined"
                                defaultValue={payment?.paymentDate ?? new Date().toISOString().slice(0, 10)}
                                errorMessage={errors.paymentDate?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="fromDate"
                                label="From Date"
                                name="fromDate"
                                type="date"
                                variant="outlined"
                                defaultValue={payment?.fromDate ?? new Date().toISOString().slice(0, 10)}
                                errorMessage={errors.fromDate?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default BusinessPaymentForm;